import { render, staticRenderFns } from "./MyHeader2.vue?vue&type=template&id=4a8aaa81&scoped=true"
import script from "./MyHeader2.vue?vue&type=script&lang=js"
export * from "./MyHeader2.vue?vue&type=script&lang=js"
import style0 from "./MyHeader2.vue?vue&type=style&index=0&id=4a8aaa81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8aaa81",
  null
  
)

export default component.exports